import React, { Component } from "react";
import EmployeesNovelties from "../../../components/EmployeesNovelties/EmployeesNovelties";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AEmployeesNoveltiesForm
Description : Componente que invoca al componente EmployeesNovelties.
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class EmployeesNoveltiesForm extends Component {
    render() {
        return (
            <EmployeesNovelties />
        )
    }
}

export default EmployeesNoveltiesForm;